(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay/assets/javascripts/account-services/player-session.js') >= 0) return;  svs.modules.push('/components/tur/pay/assets/javascripts/account-services/player-session.js');

'use strict';

async function playerSession(_ref) {
  var _svs, _svs$setupExtraData;
  let {
    next,
    saveState,
    price,
    product,
    drawCount = 1,
    team
  } = _ref;
  const extraParams = {
    amount: price,
    product,
    weeks: drawCount,
    branding: product,
    team
  };
  if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    return saveState(() => svs.components.customer_login.login({
      returnNewCustomer: true,
      extraParams
    }));
  }
  await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
    extraData: extraParams
  }));
  next();
}
svs.tur.pay.account_services.playerSession = playerSession;

 })(window);